export const RECIPE_QUERY_SEARCH_TERM = 'recipeSearch';
export const RECIPE_SEARCH_PATH = '/ecom/recipes/search';
export const RECIPE_SEARCH_ID = 'recipe-search';
export const RECIPE_QUERY_SORT_BY = 'sortBy';
export const RECIPE_QUERY_PAGE = 'page';
export const RECIPE_FILTER_SUFFIX = '_flt';

export const RECIPE_FEATURED_LAST_PUBLISHED = 'FEATURED_LAST_PUBLISHED' as const;
